import perm from './Perm'
import bzxt from './Tagging'
import crowd from './Crowd'
import search from './Search'

export default {
    perm,
    crowd,
    bzxt,
    search
}



// WEBPACK FOOTER //
// ./src/core/Apis/index.js